const RAIL_STORAGE_KEY = 'campaign.nav.rail';

/** Routes that default to the collapsed rail when the user has no stored preference. */
const RAIL_DEFAULT_PATH_PATTERNS = [
  /^\/campaigns\/[^/]+\/content(?:\/|$)/,
  /^\/templates\/create(?:\/|$)/,
  /^\/templates\/edit(?:\/|$)/,
];

export const isNavRailDefaultPath = (pathname: string): boolean =>
  RAIL_DEFAULT_PATH_PATTERNS.some((pattern) => pattern.test(pathname));

export const readNavRailPreference = (): boolean | null => {
  try {
    const value = localStorage.getItem(RAIL_STORAGE_KEY);
    if (value === null) return null;
    return value === 'true';
  } catch {
    return null;
  }
};

export const writeNavRailPreference = (railOn: boolean): void => {
  try {
    localStorage.setItem(RAIL_STORAGE_KEY, railOn ? 'true' : 'false');
  } catch {
    // Safari private mode / blocked storage — ignore
  }
};

/**
 * Resolves whether the sidebar should start collapsed (rail).
 * Stored preference wins; otherwise editor routes default to rail.
 */
export const resolveNavRailOn = (pathname = typeof window !== 'undefined' ? window.location.pathname : ''): boolean => {
  const stored = readNavRailPreference();
  if (stored !== null) return stored;
  return isNavRailDefaultPath(pathname);
};
